import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useReveal } from "../hooks/useReveal";
import { useCampaignBySlug } from "../hooks/useCampaignBySlug";
import { CaseNav } from "../components/sections/case/CaseNav";
import { CaseHero } from "../components/sections/case/CaseHero";
import { CaseImage } from "../components/sections/case/CaseImage";
import { CaseBody } from "../components/sections/case/CaseBody";
import { CaseImpact } from "../components/sections/case/CaseImpact";
import { CaseFooter } from "../components/sections/case/CaseFooter";

export default function CaseStudy() {
  const { slug } = useParams();
  const navigate = useNavigate();
  useReveal();

  const { campaign, index, next, total } = useCampaignBySlug(slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  if (!campaign) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="text-center">
          <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3">
            404 · Case Not Found
          </div>
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6">
            That case doesn&apos;t exist.
          </h1>
          <button
            onClick={() => navigate("/")}
            data-testid="case-404-back"
            className="inline-flex items-center gap-2 border border-[var(--ink)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.75} />
            Back to all work
          </button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="case-study-page" className="min-h-screen">
      <CaseNav index={index} total={total} />
      <CaseHero campaign={campaign} index={index} />
      <CaseImage campaign={campaign} />
      <CaseBody campaign={campaign} />
      <CaseImpact campaign={campaign} />
      <CaseFooter campaign={campaign} next={next} />
    </div>
  );
}
